import React, { useState } from 'react';
import { Spin, Alert, message } from 'antd';
import { useH312Query } from './hooks/useH312Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/h312Api';
import './H312Form.css';

/**
 * Get today as YYYY-MM-DD.
 */
function getToday(): string {
  return new Date().toISOString().substring(0, 10);
}

const H312Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = useH312Query();

  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState(getToday());
  const [invoiceFrom, setInvoiceFrom] = useState('');
  const [invoiceTo, setInvoiceTo] = useState('');
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');
  const [vendorFrom, setVendorFrom] = useState('');
  const [vendorTo, setVendorTo] = useState('');
  const [byVendor, setByVendor] = useState(false);
  const [byDept, setByDept] = useState(false);
  const [byDoc, setByDoc] = useState(false);

  // Track which groupBy was used for the current result
  const [activeGroupBy, setActiveGroupBy] = useState('vendor');

  const handleQuery = () => {
    // BR-V01: at least one checkbox must be checked
    if (!byVendor && !byDept && !byDoc) {
      message.warning('請至少勾選一個印表選擇（廠商別/部門別/單據別）');
      return;
    }

    // Determine groupBy — use first checked
    let groupBy = 'vendor';
    if (byVendor) groupBy = 'vendor';
    else if (byDept) groupBy = 'dept';
    else if (byDoc) groupBy = 'doc';

    setActiveGroupBy(groupBy);

    const req: QueryRequest = {
      dateFrom: dateFrom.trim(),
      dateTo: dateTo.trim(),
      invoiceFrom: invoiceFrom.trim(),
      invoiceTo: invoiceTo.trim() || (invoiceFrom.trim() ? invoiceFrom.trim() + 'zzzzzz'.substring(0, 6 - invoiceFrom.trim().length) : ''),
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim() || (deptFrom.trim() ? deptFrom.trim() + 'zzzz'.substring(0, 4 - deptFrom.trim().length) : ''),
      vendorFrom: vendorFrom.trim(),
      vendorTo: vendorTo.trim() || (vendorFrom.trim() ? vendorFrom.trim() + '\xff' : ''),
      groupBy,
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="h312-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          暫不付款請款單明細 (pwh312f1)
        </h2>

        <QueryParams
          dateFrom={dateFrom}
          dateTo={dateTo}
          invoiceFrom={invoiceFrom}
          invoiceTo={invoiceTo}
          deptFrom={deptFrom}
          deptTo={deptTo}
          vendorFrom={vendorFrom}
          vendorTo={vendorTo}
          byVendor={byVendor}
          byDept={byDept}
          byDoc={byDoc}
          loading={loading}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onInvoiceFromChange={setInvoiceFrom}
          onInvoiceToChange={setInvoiceTo}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onVendorFromChange={setVendorFrom}
          onVendorToChange={setVendorTo}
          onByVendorChange={setByVendor}
          onByDeptChange={setByDept}
          onByDocChange={setByDoc}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} groupBy={activeGroupBy} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的暫不付款請款單資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default H312Form;
